import type { Tone } from "shared/tones";
import type { Conversation, ConversationOutcome } from "../api/OutreachTouchesApi";
import { OUTCOME_LABEL } from "./ConversationActions";

/** The one "whose turn" label of a conversation, or null once it is closed (the result says it then). A silent wait folds the no-answer
 *  warning into the same label instead of a second pill. */
export function turnStatus(c: Conversation): { label: string; tone: Tone } | null {
  if (c.state === "closed") return null;
  if (c.state === "waiting_on_them") {
    return c.no_answer
      ? { label: `Waiting on them · no answer in ${c.no_answer_days} days`, tone: "warning" }
      : { label: "Waiting on them", tone: "info" };
  }
  return { label: "Waiting on us", tone: "warning" };       // their message is last, or a redirect target nobody has written to yet
}

const WARM: ConversationOutcome[] = ["interested", "interested_other_rfp", "teaming"];
/** The result a person set, or null when there is none yet (the screens call that "Open"). */
export function resultStatus(outcome: ConversationOutcome | null): { label: string; tone: Tone } | null {
  if (!outcome) return null;
  return { label: OUTCOME_LABEL[outcome], tone: WARM.includes(outcome) ? "success" : outcome === "removed" ? "danger" : "neutral" };
}
